<span
  class="op-pull-request-state"
  [class.op-pull-request-state_small]="small"
  [ngClass]="'op-pull-request-state_' + state">
  <op-icon icon-classes="button--icon icon-merge-branch"></op-icon>
  {{displayText}}
</span>
